import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  fill2542d4m9l93pn as fill,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  toByte4i43936u611k as toByte,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toShort36kaw0zjdq3ex as toShort,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  createThis2j2avj17cvnv2 as createThis,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  protoOf180f3jzyo7rfj as protoOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  isInterface3d6p8outrmvmk as isInterface,
  numberToLong1a4cndvg6c52s as numberToLong,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  toHexString18s73ly43cg6d as toHexString,
  toHexString22imn3z7nuei9 as toHexString_0,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  unsupported198cz39rr1ztw as unsupported,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  write81fg3kayjaelgo as write8,
  AsyncGetLengthStream219k26r6v6js2 as AsyncGetLengthStream,
  AsyncGetPositionStream2f8n5516y4rp7 as AsyncGetPositionStream,
  asyncStreamWriter3ock1ljgyrdbd as asyncStreamWriter,
  openSync2m3qn99fqytu0 as openSync,
  AsyncOutputStreamkoco1dsjo5gm as AsyncOutputStream,
  toAsync26jtc2k5wi4gn as toAsync,
  toAsync2pa2d6thtq8t4 as toAsync_0,
  write$default33b74pnsnzha9 as write$default,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_0,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  SimpleRingBuffer1a4k3g2va6i8y as SimpleRingBuffer,
  getU16LE2cizldw8qp53x as getU16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import { runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions } from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  CRC32_getInstance38eqfkdpicymh as CRC32_getInstance,
  Adler32_instance33daqpim0ep9p as Adler32_instance,
} from './korlibs-checksum-root-korlibs-checksum.mjs';
import { extract2vhru1ihy4ogl as extract } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var clz32 = Math.clz32;
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    this.z1x_1 = 8388608;
    this.a1y_1 = 131072;
  }
}
class Companion_0 {
  constructor() {
    this.b1y_1 = -1;
    this.c1y_1 = -2;
    this.d1y_1 = 1023;
    this.e1y_1 = 16;
    this.f1y_1 = 288;
    this.g1y_1 = true;
    this.h1y_1 = true;
    this.i1y_1 = 10;
  }
}
class SlidingWindowWithOutput {
  constructor(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.y1y_1 = sliding;
    this.z1y_1 = out;
    this.a1z_1 = flushSize;
    this.b1z_1 = extraSize;
    this.c1z_1 = FixedSizeByteArrayBuilder.z1z(this.a1z_1 + this.b1z_1 | 0);
  }
  f1z() {
    return this.c1z_1.e1z_1 >= this.a1z_1;
  }
  u1z(distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.y1y_1.e20(distance);
        this.c1z_1.c1e(toByte(v));
      }
       while (inductionVariable < length);
  }
  y1z(bytes, offset, len) {
    this.c1z_1.a1e(bytes, offset, len);
    this.y1y_1.f20(bytes, offset, len);
  }
  v1z(byte) {
    this.c1z_1.c1e(byte);
    this.y1y_1.g20(get_unsigned(byte));
  }
}
class CompressionMethod {}
function uncompress(i, o, $completion) {
  unsupported();
}
class IDeflaterInternal {}
function uncompress_0(i, o, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_0.bind(VOID, this, i, o), $completion);
}
class DeflaterPortable {
  constructor(windowBits) {
    Companion_getInstance_1();
    this.v1y_1 = windowBits;
  }
  h20(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp.bind(VOID, this, reader, out), $completion);
  }
}
class Companion_1 extends DeflaterPortable {
  constructor() {
    Companion_instance_1 = null;
    super(15);
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.compression.deflate.Companion.FIXED_TREE.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.k1z_1 = tmp_0.r1z(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.l1z_1 = tmp_2.r1z(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.m1z_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.n1z_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.o1z_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.p1z_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.q1z_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
}
class HuffmanTree {
  constructor() {
    this.j1y_1 = new Int32Array(1024);
    this.k1y_1 = new Int32Array(1024);
    this.l1y_1 = new Int32Array(1024);
    this.m1y_1 = 0;
    this.n1y_1 = 1023;
    this.o1y_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.p1y_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.q1y_1 = tmp_4;
    this.r1y_1 = new Int32Array(17);
    this.s1y_1 = new Int32Array(17);
    this.t1y_1 = new Int32Array(17);
    this.u1y_1 = new Int32Array(288);
  }
  s1z(reader) {
    reader.j20(10);
    var node = this.n1y_1;
    if (true && reader.m20() >= 10) {
      var bits = reader.k20(10);
      var raw = this.p1y_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.l20(len);
        if (value === -2) {
          node = this.q1y_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.h1z()) {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.l1y_1[this_0];
        } else {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.k1y_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.j1y_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var this_3 = node;
    return this.j1y_1[this_3];
  }
  t1z(codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.r1y_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException.s4(toString(message));
        }
        var _array__4zh2yp = this.r1y_1;
        _array__4zh2yp[codeLen] = _array__4zh2yp[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.r1y_1[n_0];
        this.s1y_1[n_0] = currentOffset;
        this.t1y_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var _array__4zh2yp_0 = this.t1y_1;
        var _unary__edvuaz = _array__4zh2yp_0[codeLen_0];
        _array__4zh2yp_0[codeLen_0] = _unary__edvuaz + 1 | 0;
        this.u1y_1[_unary__edvuaz] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.m1y_1;
        var OFFSET = this.s1y_1[i];
        var SIZE = this.r1y_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.u1y_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.y1_1;
        var last = progression.z1_1;
        var step_0 = progression.a2_1;
        if (step_0 > 0 && inductionVariable_4 <= last || (step_0 < 0 && last <= inductionVariable_4))
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 && !((oldCount % 2 | 0) === 0)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException.s4(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException.s4(toString(message_1));
    }
    this.n1y_1 = allocNode(this, this.m1y_1 - 2 | 0, this.m1y_1 - 1 | 0);
    this.o1y_1 = ncodes;
    computeFastLookup(this);
    return this;
  }
  r1z(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.t1z(codeLengths, start, end) : $super.t1z.call(this, codeLengths, start, end);
  }
}
class SlidingWindow {
  constructor(nbits) {
    this.a20_1 = nbits;
    this.b20_1 = new Int8Array(1 << this.a20_1);
    this.c20_1 = this.b20_1.length - 1 | 0;
    this.d20_1 = 0;
  }
  f1(offset) {
    return this.b20_1[(this.d20_1 - offset | 0) & this.c20_1] & 255;
  }
  e20(offset) {
    return this.g20(this.f1(offset));
  }
  g20(value) {
    this.b20_1[this.d20_1] = toByte(value);
    this.d20_1 = (this.d20_1 + 1 | 0) & this.c20_1;
    return value;
  }
  f20(bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g20(get_unsigned(bytes[offset + n | 0]));
      }
       while (inductionVariable < len);
  }
}
class FixedSizeByteArrayBuilder {
  static n20(data) {
    var $this = createThis(this);
    $this.d1z_1 = data;
    $this.e1z_1 = 0;
    return $this;
  }
  static z1z(size) {
    return this.n20(new Int8Array(size));
  }
  y2() {
    this.e1z_1 = 0;
  }
  a1e(array, offset, len) {
    arraycopy(array, offset, this.d1z_1, this.e1z_1, len);
    this.e1z_1 = this.e1z_1 + len | 0;
  }
  c1e(v) {
    var _unary__edvuaz = this.e1z_1;
    this.e1z_1 = _unary__edvuaz + 1 | 0;
    this.d1z_1[_unary__edvuaz] = v;
  }
}
class Companion_2 {
  constructor() {
    this.o20_1 = 8388608;
    this.p20_1 = 32768;
  }
}
class BitReader {
  constructor(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.q20_1 = s;
    this.r20_1 = bigChunkSize;
    this.s20_1 = readWithSize;
    this.t20_1 = 0;
    this.u20_1 = 0;
    this.v20_1 = new SimpleRingBuffer(ilog2(get_nextPowerOfTwo(this.r20_1)));
    this.w20_1 = 0.0;
    this.x20_1 = 0.0;
    this.y20_1 = new Int8Array(4);
  }
  toString() {
    return 'BitReader(' + toString(this.q20_1) + ', bigChunkSize=' + this.r20_1 + ', readWithSize=' + this.s20_1 + ')';
  }
  b21() {
    return this.v20_1.t1o_1 < this.s20_1;
  }
  z20(expectedBytes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBytesUpTo__5zpo26.bind(VOID, this, expectedBytes), $completion);
  }
  j20(bitcount) {
    while (this.u20_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.t20_1;
      // Inline function 'korlibs.compression.deflate.BitReader._su8' call
      this.w20_1 = this.w20_1 + 1;
      tmp.t20_1 = tmp_0 | this.v20_1.r1p() << this.u20_1;
      this.u20_1 = this.u20_1 + 8 | 0;
    }
  }
  k20(bitcount) {
    return this.t20_1 & ((1 << bitcount) - 1 | 0);
  }
  l20(bitcount) {
    this.t20_1 = this.t20_1 >>> bitcount | 0;
    this.u20_1 = this.u20_1 - bitcount | 0;
  }
  i1z(bitcount) {
    this.j20(bitcount);
    var readed = this.k20(bitcount);
    this.l20(bitcount);
    return readed;
  }
  h1z() {
    return !(this.i1z(1) === 0);
  }
  c21(count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.u20_1 >= 8) {
      if (!((this.u20_1 % 8 | 0) === 0)) {
        var bits = this.u20_1 % 8 | 0;
        this.l20(bits);
      }
      while (this.u20_1 >= 8) {
        var byte = toByte(this.i1z(8));
        var _unary__edvuaz = offset;
        offset = _unary__edvuaz + 1 | 0;
        out[_unary__edvuaz] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.t20_1 = 0;
    this.u20_1 = 0;
    var readCount = this.v20_1.d1p(out, offset, count_0);
    if (readCount > 0)
      this.w20_1 = this.w20_1 + readCount;
  }
  a21(count, out) {
    this.c21(count, out);
    return out;
  }
  d21() {
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.t20_1 = 0;
    this.u20_1 = 0;
    this.w20_1 = this.w20_1 + 1;
    return this.v20_1.r1p();
  }
  w1z() {
    this.c21(2, this.y20_1);
    return getU16LE(this.y20_1, 0);
  }
  e21() {
    this.c21(4, this.y20_1);
    return getS32LE(this.y20_1, 0);
  }
  f21() {
    this.c21(4, this.y20_1);
    return getS32BE(this.y20_1, 0);
  }
  g21(count, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_abytes__gje57m.bind(VOID, this, count, out), $completion);
  }
  h21(count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.g21(count, out, $completion) : $super.g21.call(this, count, out, $completion);
  }
  h1q(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, buffer, offset, len), $completion);
  }
  i1q($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  i21($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_strz__qhnc5d.bind(VOID, this), $completion);
  }
  g1s($completion) {
    return numberToLong(this.w20_1);
  }
  i1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8.bind(VOID, this), $completion);
  }
  h1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class toDeflater$1 {
  constructor($this_toDeflater) {
    this.j21_1 = $this_toDeflater;
  }
  w1y() {
    return this.j21_1.r20_1;
  }
  x1y() {
    return this.j21_1.s20_1;
  }
  m20() {
    return this.j21_1.u20_1;
  }
  j20(bits) {
    return this.j21_1.j20(bits);
  }
  x1z(count, $completion) {
    return this.j21_1.h21(count, VOID, $completion);
  }
  w1z() {
    return this.j21_1.w1z();
  }
  h1z() {
    return this.j21_1.h1z();
  }
  l20(bits) {
    return this.j21_1.l20(bits);
  }
  k20(count) {
    return this.j21_1.k20(count);
  }
  i1z(count) {
    return this.j21_1.i1z(count);
  }
  g1z($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBigChunkIfRequired__yhuuys.bind(VOID, this), $completion);
  }
}
class toDeflater$2 {
  constructor($this_toDeflater) {
    this.k21_1 = $this_toDeflater;
  }
  f1q(bytes, offset, size, $completion) {
    return this.k21_1.f1q(bytes, offset, size, $completion);
  }
}
class uncompressStream$slambda {
  constructor($this_uncompressStream, $input) {
    this.l21_1 = $this_uncompressStream;
    this.m21_1 = $input;
  }
  n21(output, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, output), $completion);
  }
  pd(p1, $completion) {
    return this.n21((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class uncompress$slambda {
  constructor($this_uncompress, $i, $o) {
    this.o21_1 = $this_uncompress;
    this.p21_1 = $i;
    this.q21_1 = $o;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class GZIPBase {
  constructor(checkCrc, deflater) {
    this.r21_1 = checkCrc;
    this.s21_1 = deflater;
  }
  toString() {
    return 'GZIPBase(' + this.r21_1 + ', ' + toString(this.s21_1) + ')';
  }
  i20(i, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_1.bind(VOID, this, i, out), $completion);
  }
}
class GZIP extends GZIPBase {
  constructor(deflater) {
    Companion_getInstance_3();
    super(true, deflater);
  }
}
class Companion_3 extends GZIP {
  constructor() {
    Companion_instance_3 = null;
    super(GZIP$Companion$_init_$lambda_4zsoc7);
    Companion_instance_3 = this;
  }
  toString() {
    return 'GZIP';
  }
}
class GZIPBase$uncompress$2 {
  constructor($out, $ccrc32, $csize) {
    this.u21_1 = $out;
    this.v21_1 = $ccrc32;
    this.w21_1 = $csize;
    this.t21_1 = $out;
  }
  i1q($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0.bind(VOID, this), $completion);
  }
  f1q(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, buffer, offset, len), $completion);
  }
}
class ZLib {
  constructor(deflater) {
    Companion_getInstance_4();
    this.z21_1 = deflater;
  }
  i20(i, o, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_2.bind(VOID, this, i, o), $completion);
  }
}
class Companion_4 extends ZLib {
  constructor() {
    Companion_instance_4 = null;
    super(ZLib$Companion$_init_$lambda_nrgg4o);
    Companion_instance_4 = this;
  }
}
class ZLib$uncompress$2 {
  constructor($o, $chash) {
    this.x21_1 = $o;
    this.y21_1 = $chash;
  }
  i1q($completion) {
    return this.x21_1.i1q($completion);
  }
  f1q(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, buffer, offset, len), $completion);
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function resetAlloc($this) {
  $this.m1y_1 = 0;
}
function alloc($this, value, left, right) {
  // Inline function 'kotlin.apply' call
  var _unary__edvuaz = $this.m1y_1;
  $this.m1y_1 = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.compression.deflate.HuffmanTree.alloc.<anonymous>' call
  $this.j1y_1[_unary__edvuaz] = value;
  $this.k1y_1[_unary__edvuaz] = left;
  $this.l1y_1[_unary__edvuaz] = right;
  return _unary__edvuaz;
}
function allocLeaf($this, value) {
  return alloc($this, value, 1023, 1023);
}
function allocNode($this, left, right) {
  return alloc($this, -1, left, right);
}
function computeFastLookup($this) {
  fill($this.p1y_1, -1);
  computeEncodedValues($this, $this.n1y_1, 0, 0);
}
function computeEncodedValues($this, node, encoded, encodedBits) {
  // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
  if ($this.j1y_1[node] === -1) {
    if (encodedBits < 10) {
      // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
      var tmp$ret$1 = $this.k1y_1[node];
      computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
      // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
      var tmp$ret$2 = $this.l1y_1[node];
      computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
    } else {
      writeVariants($this, encoded, encodedBits, node, -2);
    }
  } else {
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var tmp$ret$3 = $this.j1y_1[node];
    writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
  }
}
function writeVariants($this, encoded, encodedBits, node, nvalue) {
  var encodedInfo = nvalue & 65535 | encodedBits << 16;
  var rangeCount = 1 << (10 - encodedBits | 0);
  var inductionVariable = 0;
  if (inductionVariable < rangeCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = encoded | n << encodedBits;
      $this.p1y_1[i] = encodedInfo;
      $this.q1y_1[i] = node;
    }
     while (inductionVariable < rangeCount);
}
function *_generator_uncompress__ej2bxp($this, reader, out, $completion) {
  var sout = new SlidingWindowWithOutput(new SlidingWindow($this.v1y_1), out, reader.w1y(), reader.x1y());
  var lastBlock = false;
  var tempTree = new HuffmanTree();
  var tempDist = new HuffmanTree();
  var codeLenCodeLen = new Int32Array(32);
  var lengths = new Int32Array(512);
  while (!lastBlock) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
    if (false || sout.f1z()) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
      var tmp = sout.z1y_1.f1q(sout.c1z_1.d1z_1, 0, sout.c1z_1.e1z_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      sout.c1z_1.y2();
    }
    var tmp_0 = reader.g1z($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    lastBlock = reader.h1z();
    var blockType = reader.i1z(2);
    if (!(0 <= blockType ? blockType <= 2 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'invalid bit';
      throw IllegalStateException.s4(toString(message));
    }
    if (blockType === 0) {
      var len = reader.w1z();
      var nlen = reader.w1z();
      var nnlen = ~nlen & 65535;
      if (!(len === nnlen)) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Invalid deflate stream: len(' + len + ') != ~nlen(' + nnlen + ') :: nlen=' + nlen;
        throw IllegalStateException.s4(toString(message_0));
      }
      var tmp_1 = reader.x1z(len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      sout.y1z(bytes, 0, len);
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
      if (false || sout.f1z()) {
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
        var tmp_2 = sout.z1y_1.f1q(sout.c1z_1.d1z_1, 0, sout.c1z_1.e1z_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        sout.c1z_1.y2();
      }
    } else {
      var tree;
      var dist;
      if (blockType === 1) {
        tree = Companion_getInstance_1().k1z_1;
        dist = Companion_getInstance_1().l1z_1;
      } else {
        var hlit = reader.i1z(5) + 257 | 0;
        var hdist = reader.i1z(5) + 1 | 0;
        var hclen = reader.i1z(4) + 4 | 0;
        fill(codeLenCodeLen, 0);
        var inductionVariable = 0;
        if (inductionVariable < hclen)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            codeLenCodeLen[Companion_getInstance_1().q1z_1[i]] = reader.i1z(3);
          }
           while (inductionVariable < hclen);
        tempTree.r1z(codeLenCodeLen);
        var codeLen = tempTree;
        var hlithdist = hlit + hdist | 0;
        var n = 0;
        fill(lengths, 0);
        while (n < hlithdist) {
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var value = codeLen.s1z(reader);
          if (!(0 <= value ? value <= 18 : false)) {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.s4(toString('Invalid'));
          }
          var len_0;
          switch (value) {
            case 16:
              len_0 = reader.i1z(2) + 3 | 0;
              break;
            case 17:
              len_0 = reader.i1z(3) + 3 | 0;
              break;
            case 18:
              len_0 = reader.i1z(7) + 11 | 0;
              break;
            default:
              len_0 = 1;
              break;
          }
          var vv;
          switch (value) {
            case 16:
              vv = lengths[n - 1 | 0];
              break;
            case 17:
              vv = 0;
              break;
            case 18:
              vv = 0;
              break;
            default:
              vv = value;
              break;
          }
          fill(lengths, vv, n, n + len_0 | 0);
          n = n + len_0 | 0;
        }
        tempTree.t1z(lengths, 0, hlit);
        tempDist.t1z(lengths, hlit, hlithdist);
        tree = tempTree;
        dist = tempDist;
      }
      $l$loop: while (true) {
        var tmp_3 = reader.g1z($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var value_0 = tree.s1z(reader);
        if (value_0 === 256)
          break $l$loop;
        if (value_0 < 256) {
          sout.v1z(toByte(value_0));
        } else {
          var zlenof = value_0 - 257 | 0;
          var lengthExtra = reader.i1z(Companion_getInstance_1().m1z_1[zlenof]);
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var distanceData = dist.s1z(reader);
          var distanceExtra = reader.i1z(Companion_getInstance_1().o1z_1[distanceData]);
          var distance = Companion_getInstance_1().p1z_1[distanceData] + distanceExtra | 0;
          var length = Companion_getInstance_1().n1z_1[zlenof] + lengthExtra | 0;
          sout.u1z(distance, length);
        }
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
        if (false || sout.f1z()) {
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
          var tmp_4 = sout.z1y_1.f1q(sout.c1z_1.d1z_1, 0, sout.c1z_1.e1z_1, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
          sout.c1z_1.y2();
        }
      }
    }
  }
  // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
  if (true || sout.f1z()) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
    var tmp_5 = sout.z1y_1.f1q(sout.c1z_1.d1z_1, 0, sout.c1z_1.e1z_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    sout.c1z_1.y2();
  }
  return Unit_instance;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 255;
}
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function toDeflater(_this__u8e3s4) {
  return new toDeflater$1(_this__u8e3s4);
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function *_generator_prepareBytesUpTo__5zpo26($this, expectedBytes, $completion) {
  $l$loop_0: while ($this.v20_1.t1o_1 < expectedBytes) {
    // Inline function 'kotlin.math.min' call
    var b = $this.v20_1.p1p();
    var readCount = Math.min(expectedBytes, b);
    if (readCount <= 0)
      break $l$loop_0;
    var tmp = $this.q20_1.h1q($this.v20_1.j1p(), $this.v20_1.l1p(), readCount, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var transferred = tmp;
    if (transferred <= 0)
      break $l$loop_0;
    $this.v20_1.m1p(transferred);
    $this.x20_1 = $this.x20_1 + transferred;
  }
  return Unit_instance;
}
function *_generator_abytes__gje57m($this, count, out, $completion) {
  var tmp = $this.z20(count, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.a21(count, out);
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  var tmp = $this.z20(len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var out = $this.v20_1.d1p(buffer, offset, len);
  $this.w20_1 = $this.w20_1 + out;
  return out;
}
function *_generator_close__nh2uv0($this, $completion) {
  var tmp = $this.q20_1.i1q($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_strz__qhnc5d($this, $completion) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.y1d(4096);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.compression.deflate.BitReader.strz.<anonymous>' call
  // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
  $this.t20_1 = 0;
  $this.u20_1 = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if ($this.b21()) {
      var tmp = $this.z20($this.r20_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    $this.w20_1 = $this.w20_1 + 1;
    var c = $this.v20_1.r1p();
    if (c === 0)
      break $l$loop;
    write8(s, c);
  }
  var tmp$ret$2 = buffer.d1e();
  return toString_0(tmp$ret$2, ASCII_getInstance());
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp = $this.q20_1;
  var tmp2_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp2_safe_receiver.i1s($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function *_generator_getLength__lvva94($this, $completion) {
  var tmp = $this.q20_1;
  var tmp3_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp3_safe_receiver.h1s($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var message = 'Length not available on Stream';
    throw IllegalStateException.s4(toString(message));
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toDeflater_0(_this__u8e3s4) {
  return new toDeflater$2(_this__u8e3s4);
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function get_nextPowerOfTwo(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function *_generator_prepareBigChunkIfRequired__yhuuys($this, $completion) {
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  var this_0 = $this.j21_1;
  if (this_0.b21()) {
    var tmp = this_0.z20(this_0.r20_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_0($this, i, o, $completion) {
  var tmp = $this.h20(toDeflater(new BitReader(i)), toDeflater_0(o), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressed(_this__u8e3s4, method, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  return uncompressStream(method, _this__u8e3s4, bufferSize, $completion);
}
function uncompress_1(_this__u8e3s4, method, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
  return uncompress_2(method, _this__u8e3s4, outputSizeHint);
}
function uncompressStream(_this__u8e3s4, input, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  var tmp = 'uncompress:' + toString(_this__u8e3s4);
  return asyncStreamWriter(bufferSize, tmp, false, uncompressStream$slambda_0(_this__u8e3s4, input), $completion);
}
function uncompress_2(_this__u8e3s4, bytes, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.y1d(outputSizeHint);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.uncompress.<anonymous>' call
  uncompress_3(_this__u8e3s4, openSync(bytes), s);
  return buffer.d1e();
}
function uncompress_3(_this__u8e3s4, i, o) {
  return runBlockingNoSuspensions(uncompress$slambda_0(_this__u8e3s4, i, o));
}
function *_generator_invoke__zhh2q8($this, output, $completion) {
  var tmp = $this.l21_1.i20($this.m21_1, output, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressStream$slambda_0($this_uncompressStream, $input) {
  var i = new uncompressStream$slambda($this_uncompressStream, $input);
  var l = function (output, $completion) {
    return i.n21(output, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.o21_1.i20(toAsync($this.p21_1), toAsync_0($this.q21_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompress$slambda_0($this_uncompress, $i, $o) {
  var i = new uncompress$slambda($this_uncompress, $i, $o);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function get_Deflate() {
  _init_properties_Deflate_kt__jbr9mv();
  // Inline function 'kotlin.getValue' call
  var this_0 = Deflate$delegate;
  Deflate$factory();
  return this_0.o1();
}
var Deflate$delegate;
function Deflate(windowBits) {
  _init_properties_Deflate_kt__jbr9mv();
  return DeflaterNative(windowBits);
}
function Deflate$delegate$lambda() {
  _init_properties_Deflate_kt__jbr9mv();
  return Deflate(15);
}
function Deflate$factory() {
  return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
    return get_Deflate();
  }, null);
}
var properties_initialized_Deflate_kt_5ek8zp;
function _init_properties_Deflate_kt__jbr9mv() {
  if (!properties_initialized_Deflate_kt_5ek8zp) {
    properties_initialized_Deflate_kt_5ek8zp = true;
    Deflate$delegate = lazy(Deflate$delegate$lambda);
  }
}
function GZIP$Companion$_init_$lambda_4zsoc7() {
  return get_Deflate();
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function *_generator_close__nh2uv0_0($this, $completion) {
  var tmp = $this.t21_1.i1q($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_write__x1694l($this, buffer, offset, len, $completion) {
  if (len > 0) {
    $this.v21_1._v = CRC32_getInstance().w1x($this.v21_1._v, buffer, offset, len);
    $this.w21_1._v = $this.w21_1._v + len | 0;
    var tmp = $this.u21_1.f1q(buffer, offset, len, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_1($this, i, out, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.b21()) {
    var tmp = r.z20(r.r20_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var h0 = r.d21();
  var h1 = r.d21();
  if (!(h0 === 31) || !(h1 === 139)) {
    // Inline function 'kotlin.error' call
    var message = 'Not a GZIP file (h0=' + toHexString(toByte(h0)) + ', h1=' + toHexString(toByte(h1)) + ')';
    throw IllegalStateException.s4(toString(message));
  }
  var method = r.d21();
  if (!(method === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Just supported deflate in GZIP (method=' + method + ')';
    throw IllegalStateException.s4(toString(message_0));
  }
  var ftext = r.h1z();
  var fhcrc = r.h1z();
  var fextra = r.h1z();
  var fname = r.h1z();
  var fcomment = r.h1z();
  var reserved = r.i1z(3);
  var mtime = r.e21();
  var xfl = r.d21();
  var os = r.d21();
  var tmp_0;
  if (fextra) {
    var tmp_1 = r.h21(r.w1z(), VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0 = new Int8Array([]);
  }
  var extra = tmp_0;
  var tmp_2;
  if (fname) {
    var tmp_3 = r.i21($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = null;
  }
  var name = tmp_2;
  var tmp_4;
  if (fcomment) {
    var tmp_5 = r.i21($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_4 = tmp_5;
  } else {
    tmp_4 = null;
  }
  var comment = tmp_4;
  var crc16 = fhcrc ? r.w1z() : 0;
  var ccrc32 = {_v: CRC32_getInstance().x1x_1};
  var csize = {_v: 0};
  var tmp_6 = $this.s21_1();
  var tmp_7 = isInterface(tmp_6, IDeflaterInternal) ? tmp_6 : THROW_CCE();
  var tmp_8 = toDeflater(r);
  var tmp_9 = tmp_7.h20(tmp_8, toDeflater_0(new GZIPBase$uncompress$2(out, ccrc32, csize)), $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.b21()) {
    var tmp_10 = r.z20(r.r20_1, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  var crc32 = r.e21();
  var size = r.e21();
  if ($this.r21_1 && (!(csize._v === size) || !(ccrc32._v === crc32))) {
    invalidOp("Size doesn't match SIZE(" + toHexString_0(csize._v) + ' != ' + toHexString_0(size) + ') || CRC32(' + toHexString_0(ccrc32._v) + ' != ' + toHexString_0(crc32) + ')');
  }
  return Unit_instance;
}
function ZLib$Companion$_init_$lambda_nrgg4o(it) {
  return Deflate(it);
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  var tmp = $this.x21_1.f1q(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.y21_1._v = Adler32_instance.w1x($this.y21_1._v, buffer, offset, len);
  return Unit_instance;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function *_generator_uncompress__ej2bxp_2($this, i, o, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.b21()) {
    var tmp = r.z20(r.r20_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var cmf = r.d21();
  var flg = r.d21();
  if (!(((imul(cmf, 256) + flg | 0) % 31 | 0) === 0)) {
    // Inline function 'kotlin.error' call
    var message = 'bad zlib header';
    throw IllegalStateException.s4(toString(message));
  }
  var compressionMethod = extract(cmf, 0, 4);
  if (!(compressionMethod === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Invalid zlib stream compressionMethod=' + compressionMethod;
    throw IllegalStateException.s4(toString(message_0));
  }
  var windowBits = extract(cmf, 4, 4) + 8 | 0;
  var fcheck = extract(flg, 0, 5);
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  var hasDict = !(((flg >>> 5 | 0) & 1) === 0);
  var flevel = extract(flg, 6, 2);
  var dictid = 0;
  if (hasDict) {
    dictid = r.e21();
    // Inline function 'kotlin.TODO' call
    var reason = 'Unsupported custom dictionaries (Provided DICTID=' + dictid + ')';
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  var chash = {_v: Adler32_instance.v1x_1};
  var tmp_0 = $this.z21_1(windowBits);
  var tmp_1 = isInterface(tmp_0, IDeflaterInternal) ? tmp_0 : THROW_CCE();
  var tmp_2 = toDeflater(r);
  var tmp_3 = tmp_1.h20(tmp_2, toDeflater_0(new ZLib$uncompress$2(o, chash)), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.b21()) {
    var tmp_4 = r.z20(r.r20_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  var adler32 = r.f21();
  if (!(chash._v === adler32)) {
    invalidOp("Adler32 doesn't match " + toHexString_0(chash._v) + ' != ' + toHexString_0(adler32));
  }
  return Unit_instance;
}
function DeflaterNative(windowBits) {
  return new DeflaterPortable(windowBits);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SlidingWindowWithOutput, 'SlidingWindowWithOutput', VOID, VOID, VOID, [0, 1]);
initMetadataForInterface(CompressionMethod, 'CompressionMethod', VOID, VOID, VOID, [2, 3]);
initMetadataForInterface(IDeflaterInternal, 'IDeflaterInternal', VOID, VOID, [CompressionMethod], [2, 3]);
protoOf(DeflaterPortable).i20 = uncompress_0;
initMetadataForClass(DeflaterPortable, 'DeflaterPortable', VOID, VOID, [IDeflaterInternal], [3, 2]);
initMetadataForCompanion(Companion_1, VOID, VOID, [3, 2]);
initMetadataForClass(HuffmanTree, 'HuffmanTree', HuffmanTree);
initMetadataForClass(SlidingWindow, 'SlidingWindow');
initMetadataForClass(FixedSizeByteArrayBuilder, 'FixedSizeByteArrayBuilder');
initMetadataForCompanion(Companion_2, VOID, VOID, [1]);
initMetadataForClass(BitReader, 'BitReader', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1, 2, 3]);
initMetadataForClass(toDeflater$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(toDeflater$2, VOID, VOID, VOID, VOID, [3, 1]);
initMetadataForLambda(uncompressStream$slambda, VOID, VOID, [1]);
initMetadataForLambda(uncompress$slambda, VOID, VOID, [0]);
initMetadataForClass(GZIPBase, 'GZIPBase', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(GZIP, 'GZIP', VOID, VOID, VOID, [2, 3]);
initMetadataForCompanion(Companion_3, VOID, VOID, [2, 3]);
protoOf(GZIPBase$uncompress$2).g1q = write$default;
initMetadataForClass(GZIPBase$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 0, 3]);
initMetadataForClass(ZLib, 'ZLib', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 3]);
protoOf(ZLib$uncompress$2).g1q = write$default;
initMetadataForClass(ZLib$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [0, 3, 1]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  uncompressed as uncompressed1upyct1udgysk,
  Companion_getInstance_3 as Companion_getInstance21eog9dvyf17t,
  Companion_getInstance_4 as Companion_getInstance3mocpl8hga9iq,
  get_Deflate as get_Deflate2a0lyute7oxjd,
  uncompress_1 as uncompress3ofkd276wd0zn,
};
//endregion
